import React, { FCWithChildren } from 'react';
import { ListingProvider } from '@context/listing.context';
import { CatListProvider } from '@context/sell-catalog.context';

const SellLayout: FCWithChildren = (props) => {
  const { children } = props;

  return (
    <CatListProvider>
      <ListingProvider>{children}</ListingProvider>
    </CatListProvider>
  );
};

export default SellLayout;
